<template>
    <playerList :type="'intensity'"></playerList>
</template>

<script>
    import playerList from "@/components/newPlayerList";
    export default {
        name: "intensityReport",
        components:{
            playerList
        }
    }
</script>

<style scoped>

</style>
